import WorkspacesIcon from "@mui/icons-material/Workspaces";
import { DialogActions, DialogContent } from "@mui/material";
import {
  Autocomplete,
  Button,
  Checkbox,
  CreatedUpdatedBy,
  Field,
  FieldsContainer,
  Form,
  PageHeader,
  TextField,
} from "common";
import { ParamsContext } from "common/components/Form/ParamsContext";
import HistoryListDialog from "features/histories/HistoryListDialog";
import useAccess from "features/profile/useAccess";
import I18n from "i18n";
import { createContext } from "react";
import useOptionGroupForm, {
  UseOptionGroupFormProps,
  UseOptionGroupFormReturnType,
} from "./useOptionGroupForm";
export const OptionGroupContext = createContext<
  UseOptionGroupFormReturnType | undefined
>(undefined);
export interface OptionGroupFormProps extends UseOptionGroupFormProps {}

export default function OptionGroupForm({
  id,
  afterSave,
  onClose,
  defaultValues,
}: OptionGroupFormProps) {
  const { hasPermissions, canEditItem } = useAccess();
  const form = useOptionGroupForm({
    id,
    afterSave,
    defaultValues,
  });
  const {
    params,
    item,
    options,
    errors,
    loading,
    isDirty,
    isCreate,
    isUpdate,
    getIsDirty,
    getRequiredFields,
    onChange,
    save,
    saving,
  } = form;
  const title = isCreate ? I18n.t("OptionGroup.addTitle") : item.name;
  const subtitle = isCreate ? undefined : undefined;
  return (
    <ParamsContext.Provider value={{ option_group_id: id }}>
      <OptionGroupContext.Provider value={form}>
        <PageHeader
          avatar={<WorkspacesIcon />}
          title={title}
          subtitle={subtitle}
          onClose={onClose}
          loading={loading}
        />
        <DialogContent>
          <Form
            loading={loading}
            item={item}
            options={options}
            errors={errors}
            onChange={onChange}
            translationCategory="OptionGroup.attributes"
            translationPlaceholdersCategory="OptionGroup.placeholders"
            translationHelpersCategory="OptionGroup.helpers"
            isDirty={getIsDirty}
            requiredFields={getRequiredFields()}
            disabled={!canEditItem("option_group", item)}
          >
            <FieldsContainer>
              <Field fullWidth>
                <TextField id="name" />
              </Field>
              <Field fullWidth>
                <Autocomplete id="type" />
              </Field>
              <Field fullWidth>
                <Checkbox id="has_price" />
              </Field>
              <Field fullWidth>
                <Checkbox id="has_description" />
              </Field>
              <Field fullWidth>
                <Checkbox id="required" />
              </Field>
              <Field fullWidth>
                <Checkbox id="kitchen" />
              </Field>
              <Field fullWidth>
                <Checkbox id="active" />
              </Field>{" "}
            </FieldsContainer>
          </Form>
        </DialogContent>
        <DialogActions>
          {isUpdate && (
            <CreatedUpdatedBy
              objectName="OptionGroup"
              item={item}
              sx={{
                p: 1,
                paddingTop: 0,
                paddingBottom: 0.5,
                marginRight: "auto",
              }}
              renderDialog={
                hasPermissions(["history.viewany", "history.viewown"])
                  ? props => <HistoryListDialog {...props} subtitle={title} />
                  : undefined
              }
            />
          )}
          <Button
            title={I18n.t("App.save")}
            disabled={!isDirty}
            onClick={() => save()}
            loading={saving}
          />
        </DialogActions>
      </OptionGroupContext.Provider>
    </ParamsContext.Provider>
  );
}
